
// src/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; 
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD2HNAPZM-nWxIZbOJMKqksQ3mI6RtzMtY",
  authDomain: "avaamiop.firebaseapp.com",
  projectId: "avaamiop",
  storageBucket: "avaamiop.firebasestorage.app",
  messagingSenderId: "679539711774",
  appId: "1:679539711774:web:20f6d1fe00da8b41be330f",
  measurementId: "G-S1FQMCJFX2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize auth BEFORE using setPersistence
export const auth = getAuth(app);

// Set local persistence
setPersistence(auth, browserLocalPersistence);

// Firebase services
export const db = getFirestore(app); 
export const storage = getStorage(app); 
export const googleProvider = new GoogleAuthProvider();

export default app;
